import React from 'react';
import { Spin } from 'antd';
import { LocalizationLoader } from '../../translate';
import { ZoneMigrationPaywallProps } from './ZoneMigrationPaywall';
import { ZoneMigrationPaywallModalProps } from './ZoneMigrationPaywallModal';

const LazyZoneMigrationPaywallModal = React.lazy(
	() => import('./ZoneMigrationPaywallModal')
);
export const AsyncZoneMigrationPaywallModal: React.FC<
	ZoneMigrationPaywallModalProps
> = props => (
	<React.Suspense fallback={<Spin />}>
		<LocalizationLoader loadingElement={<Spin />}>
			{() => <LazyZoneMigrationPaywallModal {...props} />}
		</LocalizationLoader>
	</React.Suspense>
);

export const LazyZoneMigrationlPaywall = React.lazy(
	() => import('./ZoneMigrationPaywall')
);
export const AsyncZoneMigrationPaywall: React.FC<ZoneMigrationPaywallProps> = props => (
	<React.Suspense fallback={<Spin />}>
		<LocalizationLoader loadingElement={<Spin />}>
			{() => <LazyZoneMigrationlPaywall {...props} />}
		</LocalizationLoader>
	</React.Suspense>
);
